import styled from 'styled-components';
import { Flex } from '../../layout/Flex';

export const Wrapper = styled(Flex).withConfig({ displayName: 'ContentPromotionDate' }).attrs({
    p: 2,
    borderRadius: 2,
    width: '100%',
    background: 'var(--background-primary)',
})``;
